import { Navbar, NavbarBrand, Image, Container } from "react-bootstrap";

export default function NavMenu() {
  return (
    <Navbar variant="dark" className="bg-light">
      <Container fluid={true}>
        <NavbarBrand>
          <a href="https://abpn.org">
            <Image
              style={{ height: "80px" }}
              src={`${process.env.PUBLIC_URL}/abpn_logo_color.png`}
              alt="American Board of Psychiatry and Neurology, Inc."
            />
          </a>
        </NavbarBrand>
      </Container>
    </Navbar>
  );
}
